import i18n from '@/i18n/i18n.js'

const { t } = i18n.global

export const ADDRESS_ERROR_MESSAGES = {
  getCitiesError: t('constants.error_messages.address_error_messages.cities_error'),
  getCountiesError: t('constants.error_messages.address_error_messages.counties_error'),
  getDistrictsError: t('constants.error_messages.address_error_messages.districts_error'),
  getNeighborhoodsError: t('constants.error_messages.address_error_messages.neighborhoods_error')
}

export const FINDEKS_ERROR_MESSAGES = {
  getPhonesError: t('constants.error_messages.findeks_error_messages.phones_error'),
  tcknError: t('constants.error_messages.findeks_error_messages.tckn_error'),
  getPhonesFromTcknError: t('constants.error_messages.findeks_error_messages.phones_from_tckn_error')
}

export const APPLICATION_ERROR_MESSAGES = {
  getApplicationsError: t('constants.error_messages.application_error_messages.applications_error'),
  getApplicationError: t('constants.error_messages.application_error_messages.application_error'),
  confirmOrderConfirmationCodeError: t(
    'constants.error_messages.application_error_messages.confirm_order_confirmation_code_error'
  ),
  getOrderDocumentsError: t('constants.error_messages.application_error_messages.order_documents_error'),
  getWaitingApplicationsError: t('constants.error_messages.application_error_messages.waiting_applications_error'),
  getRejectedByOtherReasonApplicationsError: t(
    'constants.error_messages.application_error_messages.rejected_by_other_reason_applications_error'
  ),
  confirmError: t('constants.error_messages.application_error_messages.confirm_error'),
  regeneratePinError: t('constants.error_messages.application_error_messages.regenerate_pin_error'),
  referralCodeError: t('constants.error_messages.application_error_messages.referral_code_error'),
  completeError: t('constants.error_messages.application_error_messages.complete_error'),
  completedStateViolation: t('constants.error_messages.application_error_messages.completed_state_violation'),
  statisticsError: t('constants.error_messages.application_error_messages.statistics_error')
}

export const AUTH_ERROR_MESSAGES = {
  loginError: t('constants.error_messages.auth_error_messages.login_error'),
  logoutError: t('constants.error_messages.auth_error_messages.logout_error'),
  verifyError: t('constants.error_messages.auth_error_messages.verify_error'),
  registerError: t('constants.error_messages.auth_error_messages.register_error'),
  forgotPasswordError: t('constants.error_messages.auth_error_messages.forgot_password_error'),
  resetPasswordError: t('constants.error_messages.auth_error_messages.reset_password_error'),
  policyError: t('constants.error_messages.auth_error_messages.policy_error'),
  saveActivitiesError: t('constants.error_messages.auth_error_messages.save_activities_error'),
  getUserError: t('constants.error_messages.auth_error_messages.get_user_error'),
  userMayNotBeLoaded: t('constants.error_messages.auth_error_messages.user_may_not_be_loaded')
}

export const CROP_ERROR_MESSAGES = {
  getCropsError: t('constants.error_messages.crop_error_messages.crops_error')
}

export const DASHBOARD_ERROR_MESSAGES = {
  getDashboardError: t('constants.error_messages.dashboard_error_messages.dashboard_error'),
  getDashboardMenuItemsBadgeCountError: t(
    'constants.error_messages.dashboard_error_messages.dashboard_menu_items_badge_count_error'
  ),
  getLastOrdersError: t('constants.error_messages.dashboard_error_messages.last_orders_error'),
  getSeasonInfoError: t('constants.error_messages.dashboard_error_messages.season_info_error'),
  getRankingError: t('constants.error_messages.dashboard_error_messages.ranking_error'),
  getCarCampaignError: t('constants.error_messages.dashboard_error_messages.car_campaign_error')
}

export const FARMER_ERROR_MESSAGES = {
  getFarmerError: t('constants.error_messages.farmer_error_messages.farmer_error'),
  getFarmersError: t('constants.error_messages.farmer_error_messages.farmers_error'),
  editFarmerError: t('constants.error_messages.farmer_error_messages.edit_farmer_error'),
  getStatisticsError: t('constants.error_messages.farmer_error_messages.statistics_error'),
  getGtsDataError: t('constants.error_messages.farmer_error_messages.gts_data_error'),
  getCouponsError: t('constants.error_messages.farmer_error_messages.coupons_error'),
  assignCouponError: t('constants.error_messages.farmer_error_messages.assign_coupon_error'),
  removeCouponError: t('constants.error_messages.farmer_error_messages.remove_coupon_error'),
  getFarmersHaveLimitError: t('constants.error_messages.farmer_error_messages.farmers_have_limit_error'),
  getFarmerKycFileError: t('constants.error_messages.farmer_error_messages.farmers_kyc_document_error')
}

export const SUPPLIER_ERROR_MESSAGES = {
  getSupplierError: t('constants.error_messages.supplier_error_messages.supplier_error'),
  getSuppliersError: t('constants.error_messages.supplier_error_messages.suppliers_error'),
  createSupplierError: t('constants.error_messages.supplier_error_messages.create_supplier_error'),
  editSupplierError: t('constants.error_messages.supplier_error_messages.edit_supplier_error')
}

export const SUPPLIER_CONTACT_ERROR_MESSAGES = {
  getSupplierContactsError: t('constants.error_messages.supplier_contact_error_messages.supplier_contacts_error'),
  createSupplierContactError: t(
    'constants.error_messages.supplier_contact_error_messages.create_supplier_contact_error'
  ),
  editSupplierContactError: t('constants.error_messages.supplier_contact_error_messages.edit_supplier_contact_error'),
  deleteSupplierContactError: t(
    'constants.error_messages.supplier_contact_error_messages.delete_supplier_contact_error'
  )
}

export const SUPPLIER_DRIVER_ERROR_MESSAGES = {
  getSupplierDriversError: t('constants.error_messages.supplier_driver_error_messages.supplier_drivers_error'),
  createSupplierDriverError: t('constants.error_messages.supplier_driver_error_messages.create_supplier_driver_error'),
  editSupplierDriverError: t('constants.error_messages.supplier_driver_error_messages.edit_supplier_driver_error'),
  deleteSupplierDriverError: t('constants.error_messages.supplier_driver_error_messages.delete_supplier_driver_error'),
  getSupplierDriverError: t('constants.error_messages.supplier_driver_error_messages.supplier_driver_error')
}

export const SUPPLIER_VEHICLE_ERROR_MESSAGES = {
  getSupplierVehiclesError: t('constants.error_messages.supplier_vehicle_error_messages.supplier_vehicles_error'),
  createSupplierVehicleError: t(
    'constants.error_messages.supplier_vehicle_error_messages.create_supplier_vehicle_error'
  ),
  editSupplierVehicleError: t('constants.error_messages.supplier_vehicle_error_messages.edit_supplier_vehicle_error'),
  deleteSupplierVehicleError: t(
    'constants.error_messages.supplier_vehicle_error_messages.delete_supplier_vehicle_error'
  )
}

export const SUPPLIER_STATUS_ERROR_MESSAGES = {
  getSupplierStatusesError: t('constants.error_messages.supplier_status_error_messages.supplier_status_error'),
  createSupplierStatusError: t('constants.error_messages.supplier_status_error_messages.create_supplier_status_error')
}

export const RETAILER_GOAL_ERROR_MESSAGES = {
  getGoalsError: t('constants.error_messages.retailer_goal_error_messages.goals_error'),
  getGoalError: t('constants.error_messages.retailer_goal_error_messages.goal_error')
}

export const HOLIDAY_ERROR_MESSAGES = {
  getHolidaysError: t('constants.error_messages.holiday_error_messages.holidays_error'),
  getHolidayError: t('constants.error_messages.holiday_error_messages.holiday_error')
}

export const ORDER_ERROR_MESSAGES = {
  getOrdersError: t('constants.error_messages.order_error_messages.orders_error'),
  getPromissoryNoteError: t('constants.error_messages.order_error_messages.promissory_note_error'),
  getInvoiceError: t('constants.error_messages.order_error_messages.invoice_error'),
  getSalesContractError: t('constants.error_messages.order_error_messages.sales_contract_error'),
  getTransportationDocumentError: t('constants.error_messages.order_error_messages.transportation_document_error'),
  getRepaymentScheduleError: t('constants.error_messages.order_error_messages.repayment_schedule_error'),
  getCreditAgreementError: t('constants.error_messages.order_error_messages.credit_agreement_error'),
  viewInvoiceError: t('constants.error_messages.order_error_messages.view_invoice_error'),
  viewPromissoryNoteError: t('constants.error_messages.order_error_messages.view_promissory_note_error'),
  viewCarSalesInstallmentPromissoryNoteError: t('constants.error_messages.order_error_messages.view_car_sales_installment_promissory_note_error'),
  viewTractorSalesInstallmentPromissoryNoteError: t('constants.error_messages.order_error_messages.view_tractor_sales_installment_promissory_note_error'),
  viewVehicleRegistrationError: t('constants.error_messages.order_error_messages.view_vehicle_registration_error'),
  viewSalesContractError: t('constants.error_messages.order_error_messages.view_sales_contract_error'),
  viewTransportationDocumentError: t(
    'constants.error_messages.order_error_messages.view_transportation_document_error'
  ),
  getWorkflowJobsError: t('constants.error_messages.order_error_messages.workflow_job_error'),
  getOrderReceiptError: t('constants.error_messages.order_error_messages.order_receipt_error'),
  getPromissoryNoteAndOrderReceipError: t(
    'constants.error_messages.order_error_messages.promissory_note_and_order_receipt_error'
  ),
  getRetailerDeliveryWorkflowJobAnswers: t('constants.error_messages.order_error_messages.workflow_job_answers_error'),
  getScannedPromissoryNoteVersions: t(
    'constants.error_messages.order_error_messages.scanned_promissory_note_versions_error'
  ),
  getInstallmentSalesContractVersions: t(
    'constants.error_messages.order_error_messages.installment_sales_contract_versions_error'
  )
}

export const FINANCING_COST_SUMMARY_ERROR_MESSAGES = {
  exportError: t('constants.error_messages.financing_cost_summary_error_messages.export_error'),
  multipleExportError: t('constants.error_messages.financing_cost_summary_error_messages.multiple_export_error')
}

export const PAYMENT_ERROR_MESSAGES = {
  getOrderPaymentsError: t('constants.error_messages.payment_error_messages.order_payments_error')
}

export const PRODUCT_ERROR_MESSAGES = {
  getProductsError: t('constants.error_messages.product_error_messages.products_error'),
  updateProductError: t('constants.error_messages.product_error_messages.update_product_error')
}

export const PURCHASE_ERROR_MESSAGES = {
  getPurchasePeriodsError: t('constants.error_messages.purchase_error_messages.purchase_periods_error')
}

export const RETAILER_ERROR_MESSAGES = {
  getSalesChannelsError: t('constants.error_messages.retailer_error_messages.sales_channel_errors'),
  getNotificationsError: t('constants.error_messages.retailer_error_messages.notifications_error'),
  editRetailerError: t('constants.error_messages.retailer_error_messages.edit_retailer_error'),
  checkBrandsError: t('constants.error_messages.retailer_error_messages.check_brands_error'),
  getMobileProductsError: t('constants.error_messages.retailer_error_messages.mobile_products_error'),
  removeMobileProductError: t('constants.error_messages.retailer_error_messages.remove_mobile_product_error'),
  getPaymentethodsError: t('constants.error_messages.retailer_error_messages.payment_methods_error'),
  getSubRetailersError: t('constants.error_messages.retailer_error_messages.sub_retailers_error'),
  getSubRetailerError: t('constants.error_messages.retailer_error_messages.sub_retailer_error'),
  getSubRetailerStatisticsError: t('constants.error_messages.retailer_error_messages.sub_retailer_statistics_error'),
  getSubRetailerOrdersError: t('constants.error_messages.retailer_error_messages.sub_retailer_orders_error'),
  getRetailerContactsError: t('constants.error_messages.retailer_error_messages.retailer_contacts_error'),
  saveRetailerContactError: t('constants.error_messages.retailer_error_messages.save_retailer_contact_error'),
  editRetailerContactError: t('constants.error_messages.retailer_error_messages.edit_retailer_contact_error'),
  deleteRetailerContactError: t('constants.error_messages.retailer_error_messages.delete_retailer_contact_error'),
  getRetailerListError: t('constants.error_messages.retailer_error_messages.retailer_list_error'),
  getRetailerCountError: t('constants.error_messages.retailer_error_messages.retailer_count_error'),
  getRetailerUserError: t('constants.error_messages.retailer_error_messages.retailer_user_error'),
  getRetailerError: t('constants.error_messages.retailer_error_messages.get_retailer_error'),
  getPaymentMethodsError: t('constants.error_messages.retailer_error_messages.payment_methods_error'),
  searchProductWithCategoryError: t(
    'constants.error_messages.retailer_error_messages.search_product_with_category_error'
  )
}

export const SURVEY_ERROR_MESSAGES = {
  getQuestionsError: t('constants.error_messages.survey_error_messages.questions_error'),
  getQuestionsByTargetError: t('constants.error_messages.survey_error_messages.questions_by_target_error'),
  getRetailerQuestionsError: t('constants.error_messages.survey_error_messages.retailer_questions_error'),
  saveRetailersAnswersError: t('constants.error_messages.survey_error_messages.retailers_answers_error')
}

export const USER_ERROR_MESSAGES = {
  getUserError: t('constants.error_messages.user_error_messages.get_user_error'),
  editPasswordError: t('constants.error_messages.user_error_messages.edit_password_error'),
  createUserError: t('constants.error_messages.user_error_messages.create_user_error'),
  deleteUserError: t('constants.error_messages.user_error_messages.delete_user_error')
}

export const MERNIS_ERROR_MESSAGES = {
  mernisMismatch: t('constants.error_messages.mernis_error_messages.mernis_mismatch')
}

export const BASE_INTEREST_RATE_ERROR_MESSAGES = {
  notFoundError: t('constants.error_messages.base_interest_rate_error_messages.not_found_error')
}

export const BRAND_ERROR_MESSAGES = {
  getBrandsError: t('constants.error_messages.brand_error_messages.brands_error'),
  getUnbrandedBrandError: t('constants.error_messages.brand_error_messages.unbranded_brand_error'),
  attachBrandError: t('constants.error_messages.brand_error_messages.attach_brand_error'),
  removeBrandError: t('constants.error_messages.brand_error_messages.remove_brand_error')
}

export const PRICE_ERROR_MESSAGES = {
  getPricesError: t('constants.error_messages.price_error_messages.prices_error'),
  savePricesError: t('constants.error_messages.price_error_messages.save_prices_error'),
  savePriceError: t('constants.error_messages.price_error_messages.save_price_error'),
  deletePriceError: t('constants.error_messages.price_error_messages.delete_price_error')
}

export const TARFIN_PRO_PRODUCT_PRICE_ERROR_MESSAGES = {
  getPricesError: t('constants.error_messages.tarfin_pro_product_price_error_messages.prices_error'),
  savePricesError: t('constants.error_messages.tarfin_pro_product_price_error_messages.save_prices_error'),
  deletePriceError: t('constants.error_messages.tarfin_pro_product_price_error_messages.delete_price_error'),
  marketStatusChangeError: t(
    'constants.error_messages.tarfin_pro_product_price_error_messages.market_status_change_error'
  ),
  getMarketStatusError: t('constants.error_messages.tarfin_pro_product_price_error_messages.get_market_status_error')
}

export const COMPANY_ERROR_MESSAGES = {
  getCompanyByCuiError: t('constants.error_messages.company_error_messages.company_by_cui_error'),
  getCompaniesError: t('constants.error_messages.company_error_messages.get_companies')
}

export const STOCK_INPUT_ERROR_MESSAGES = {
  getStocksError: t('constants.error_messages.stock_input_error_messages.stocks_error')
}

export const INVOICE_ERROR_MESSAGES = {
  getInvoiceError: t('constants.error_messages.invoice_error_messages.order_receipt_error')
}

export const REFERRAL_CODE_ERROR_MESSAGES = {
  checkReferralCode: t('constants.error_messages.referral_code_error_messages.check_referral_code')
}

export const TARFIN_PRO_QUOTATION_ERROR_MESSAGES = {
  getRequestsError: t('views.retailer.tarfin_pro_requests.error_occurred_getting_requests'),
  getRequestError: t('views.retailer.tarfin_pro_requests.error_occurred_getting_request'),
  getQrCodeError: t('views.retailer.tarfin_pro_requests.error_occurred_generating_qr_code'),
  getCategoriesError: t('views.retailer.tarfin_pro_requests.error_occurred_generating_categories'),
  getProductsError: t('views.retailer.tarfin_pro_requests.error_occurred_generating_products')
}

export const FINDEKS_REQUEST_ERROR_MESSAGES = {
  getFindeksRequestErrorMessage: t('views.retailer.findeks_request.error_while_getting_findeks_request'),
  getFindeksReportErrorMessage: t('views.retailer.findeks_request.error_while_requesting_findeks_report'),
  getFindeksPhonesErrorMessage: t('views.retailer.findeks_request.error_while_getting_findeks_phones'),
  confirmFindeksPinErrorMessage: t('views.retailer.findeks_request.error_while_confirming_findeks_pin'),
  resendFindeksPinErrorMessage: t('views.retailer.findeks_request.error_while_resending_findeks_pin')
}
